import script from "./ServiceBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceBooking.vue?vue&type=script&setup=true&lang=js"

import "./ServiceBooking.vue?vue&type=style&index=0&id=a8eb3342&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8eb3342"]])

export default __exports__